import { z } from 'zod';
import { templateBaseSchema } from './base';
import {
  templateFontSizeSchema,
  templateTextAlignSchema,
  templateTextColorSchema,
  templateTextFormatSchema,
  templateTextStyleSchema,
} from './typography';

export const templateParagraphSchema = templateBaseSchema.extend({
  type: z.literal('paragraph'),
  content: z.string(),
  align: templateTextAlignSchema,
  indent: z.number().int().nonnegative(),
  color: templateTextColorSchema,
  textFormat: z.array(templateTextFormatSchema),
  fontSize: templateFontSizeSchema,
  textStyle: templateTextStyleSchema.optional().default('default'),
});

export type TemplateParagraphV1 = z.infer<typeof templateParagraphSchema>;
